import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
import router from './router'

import vuetify from './vuetify'

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'

import axios from 'axios'

import DateLocaleFilter from './shared/DateFilter'


Vue.config.productionTip = false
Vue.prototype.$eventBus = new Vue()
Vue.prototype.getRandomRange = (min=0, max=5, round=false) => {
    if(round) return Math.random() * (max - min) + min
    if(!round) return Math.floor(Math.random() * (max - min + 1)) + min
}

Vue.prototype.$api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        'Accept': 'application/json',
		'Content-Type': 'application/json'
    }
})

Vue.use(DateLocaleFilter)
Vue.use(VueRouter)
Vue.component('v-chart', ECharts)

new Vue({
    vuetify,
    router,
	render: function (h) { return h(App) }
}).$mount('#app')
